import { CommonModule, NgFor } from "@angular/common";
import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Renderer2,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-hero",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./hero.component.html",
  styleUrls: ["./hero.component.css"],
})
export class HeroComponent implements AfterViewInit, OnInit {
  @ViewChild("slidesContainer", { static: false }) slidesContainer!: ElementRef;
  @ViewChild("sliderDotsContainer", { static: false })
  sliderDotsContainer!: ElementRef;

  currentSlide = 0;
  autoSlideInterval: any;

  slidesData = [
    {
      titleHighlight: " Smart. ",
      title: "Secure. Seamless.",
      description:
        " The all-in-one platform powering the future of estates — from digital access to verified home listings.",
      imageUrl: "../../../assets/GIFS/visitor.gif",
      altText: "Smart Access Demo",
    },
    {
      titleHighlight: "Your Estate,",
      title: "In Your Pocket.",
      description:
        "Empower residents with a mobile app for payments, community updates, and services.",
      imageUrl: "../../../assets/GIFS/visitor.gif",
      altText: "Resident App Demo",
    },
    // {
    //   titleHighlight: "Proactive Safety.",
    //   title: "Instant Response.",
    //   description:
    //     "Tools for patrol tracking, incident reporting, and emergency notifications.",
    //   imageUrl:
    //     "https://placehold.co/600x400/2ECC71/FFFFFF/gif?text=Security+Patrol+Demo",
    //   altText: "Security Patrol Demo",
    // },
    // {
    //   titleHighlight: "Smarter Home Discovery.",
    //   title: "Verified Property Deals.",
    //   description:
    //     " Estate360 Homes is a secure P2P property platform to buy, rent, or sell homes — with verified listings, agent profiles, mortgage support, and logistics integration for seamless transitions.",
    //   imageUrl:
    //     "https://placehold.co/600x400/E67E22/FFFFFF/gif?text=Admin+Dashboard+Demo",
    //   altText: "Admin Dashboard Demo",
    // },
  ];

  constructor(private renderer: Renderer2, private router: Router) {}
  ngOnInit(): void {}
  ngAfterViewInit(): void {
    this.startAutoSlide();
  }

  nextSlide(): void {
    this.currentSlide = (this.currentSlide + 1) % this.slidesData.length;
    this.resetAutoSlide();
  }
  t;

  prevSlide(): void {
    this.currentSlide =
      (this.currentSlide - 1 + this.slidesData.length) % this.slidesData.length;
    this.resetAutoSlide();
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.resetAutoSlide();
  }

  startAutoSlide(): void {
    this.autoSlideInterval = setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.slidesData.length;
    }, 5000);
  }

  resetAutoSlide(): void {
    clearInterval(this.autoSlideInterval);
    this.startAutoSlide();
  }

  productView() {
    this.router.navigate(["product-view"]);
  }
}
